export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-01.7101acd4.jpg";